module.exports = __webpack_public_path__ + "img/jigou5.311ac112.png";